export function initFirebaseAppCheck(): void {
  return
}

export async function getFirebaseAppCheckToken(): Promise<string> {
  return Promise.resolve('')
}
